// components/Header.js
import React, { useState, useEffect } from 'react';
import logo from '../assets/kriyadb-logo.png';
import './Header.css';

function Header() {
  const [showEmail, setShowEmail] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="logo">
        <img src={logo} alt="KriyaDB Logo" className="logo-image" />
        <span className="logo-text">KriyaDB</span>
      </div>
      <nav>
        <ul>
          <li><a href="#architecture">Architecture</a></li>
          <li><a href="#features">Features</a></li>
          <li><a href="#use-cases">Use Cases</a></li>
          <li
            className="contact-item"
            onMouseEnter={() => setShowEmail(true)}
            onMouseLeave={() => setShowEmail(false)}
          >
            <a href="#contact">Contact</a>
            {showEmail && (
              <div className="email-tooltip">
                <a href="mailto:ram@kriyadb.com">ram@kriyadb.com</a>
              </div>
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
